<template>
  <q-markup-table dense>
    <thead>
      <tr>
        <th class="text-center">Accesorio</th>
        <th class="text-center">Cantidad</th>
        <th class="text-center">Precio Unitario</th>
        <th class="text-center">Descuento Comercial</th>
        <th class="text-center">Total</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <GltnSelectPuertaAccesorio
            dense
            v-model="form.producto"
            @update:model-value="updateItemValues($event, 'producto')"
            :errors="res.getErrors('producto')"
          />
        </td>
        <td>
          <GltnInputNumber
            dense
            v-model.number="form.cantidad"
            @update:model-value="updateItemValues($event, 'cantidad')"
            :errors="res.getErrors('cantidad')"
            :suffix="form.producto?.um"
          />
        </td>
        <td class="text-right">{{ precio_unitario }}</td>
        <td class="text-right">
          <GltnInputNumber
            dense
            v-model.number="form.descuento_comercial"
            @update:model-value="updateItemValues($event, 'descuento_comercial')"
            :errors="res.getErrors('descuento_comercial')"
            suffix="%"
          />
        </td>

        <td class="text-right">{{ total }}</td>
        <td class="text-center">
          <q-btn :disable="!res.valid" icon="add" size="sm" flat color="green" round @click="itemAdd()" />
        </td>
      </tr>
      <template v-for="(item, index) in items" :key="item">
        <tr>
          <td class="text-center">{{ item.producto?.label }}</td>
          <td class="text-right">
            {{ numberFormat(item.cantidad, true) }}
            {{ item.producto?.um }}
          </td>
          <td class="text-right">
            {{ numberFormat(item.precio_unitario) }}
          </td>
          <td class="text-right">{{ numberFormat(item.descuento_comercial, true) }}%</td>
          <td class="text-right">{{ numberFormat(item.total) }}</td>
          <td class="text-center">
            <q-btn
              icon="delete"
              size="sm"
              flat
              color="red"
              round
              @click="itemRemove(index)"
            />
          </td>
        </tr>
      </template>
      <tr>
        <td colspan="4" class="text-weight-bold text-right">TOTAL</td>
        <td class="text-weight-bold text-right">{{ totalItems }}</td>
        <td></td>
      </tr>
    </tbody>
  </q-markup-table>
</template>

<script setup>
import { reactive, computed, ref, onMounted } from "vue";
import { usePrecioCalc } from "@/composables/usePrecioCalc";
import GltnInputNumber from "@/components/form/GltnInputNumber.vue";
import GltnSelectPuertaAccesorio from "@/components/form/GltnSelectPuertaAccesorio.vue";
import numberFormat from "@/helpers/numberFormat.ts";
import suite from "./ProductoPuertaAccValidation.js";

const form = reactive({
  producto: "",
  cantidad: 1,
  precio_unitario: 0,
  total: 0,
  producto_id: "",
  descuento_comercial: 0,
  descuento_estrategico: 0,
});

const totalItems = computed(() =>
  numberFormat(items.value.reduce((x, y) => x + y.total, 0))
);

const items = defineModel("items", { default: [] });

const updateItemValues = (valor, campo) => {
  form.precio_unitario = form.producto?.precio;
  form.total = form.cantidad * form.producto?.precio;
  form.producto_id = form.producto?.value;
  validate(valor, campo);
};

const itemAdd = () => {
  items.value.push({ ...form });
  form.cantidad = 1;
  form.precio_unitario = 0;
  form.descuento_comercial = 0;
  form.descuento_estrategico = 0;
  form.total = 0;
  form.producto = "";
};

// VALIDACION
const res = ref();
res.value = suite.get();
const validate = (value, name) => {
  res.value = suite(name, form);
};

onMounted(() => {
  validate();
});

const {
  total,
  subtotal,
  precio_unitario,
  descuento_comercial,
  descuento_estrategico,
} = usePrecioCalc(form);

const itemRemove = (index) => items.value.splice(index, 1);
</script>
